import { useStyles } from "./styles";
import { StatusIntegrationCompanyEnum } from "@/main/services/enum/StatusIntegrationCompanyEnum";

interface Props {
	idStatus: StatusIntegrationCompanyEnum;
	name: string;
}

export default function StatusIntegrationCompany({ idStatus, name }: Props) {
	const classes = useStyles();

	const renderColor = () => {
		switch (idStatus) {
			case StatusIntegrationCompanyEnum.Active:
				return "#00cc66";
			case StatusIntegrationCompanyEnum.Suspended:
				return "#ff9900";
			default:
				return "#949494";
		}
	};
	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={name}
			style={{ backgroundColor: renderColor() }}
		>
			<span className={classes.spanContainer}>{name}</span>
		</div>
	);
}
